import { render, staticRenderFns } from "./MatchHistory.vue?vue&type=template&id=15c7a1b0&scoped=true&"
import script from "./MatchHistory.vue?vue&type=script&lang=js&"
export * from "./MatchHistory.vue?vue&type=script&lang=js&"
import style0 from "./MatchHistory.vue?vue&type=style&index=0&id=15c7a1b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c7a1b0",
  null
  
)

export default component.exports